import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    height: 100vh;
    width: 100vw;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
`;

function FullPageLoading() {
    return (
        <Container data-loading="page">
        </Container>
    );
}

export default FullPageLoading;
